module.exports = __webpack_public_path__ + "BP.svg?8785ab2fd3120ce9ddb42f653e69f368";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/symbols/BP.svg
// module id = 54
// module chunks = 0